/**
 * Invokes the passed function for each item in an iterable
 */
export default async function* forEach(source, fn) {
    for await (const thing of source) {
        await fn(thing);
        yield thing;
    }
}
